import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Search } from 'react-bootstrap-icons';


function LoadingAnimation(){

    return (
        <> 
            <Container>
                <Row>
                    <Col>
                        Loading...
                    </Col>
                </Row>
                <div className="loading-spinner square-image-block">
                    
                </div>
            </Container>
        </>
    )
}

export default LoadingAnimation;